const footer = () => {

    return (
        <footer className="App-footer">
            <p>© 2026 Alpha DogWalks. All rights reserved.</p>
        </footer>

    )
}

export default footer;